import { HouseholdsPage } from "./pages/HouseholdsPage";
import { CreateHouseholdPage } from "./pages/CreateHouseholdPage";
import {RequireAuth} from "@/features/auth/components/RequireAuth.jsx";

export const householdsRoutes = {
  path: "/admin/organizations",
  element: <RequireAuth />,
  children: [{
    path: "",
    element: <HouseholdsPage />,
  }, {
    path: "create",
    element: <CreateHouseholdPage />,
  }]
};
